<template>
  <div class="home-page">
    <!-- 轮播图部分 -->
    <van-swipe class="swiper" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(image, index) in bannerImages" :key="index">
        <van-image :src="image" fit="cover" width="100%" height="200" />
      </van-swipe-item>
    </van-swipe>

    <!-- 功能区块 -->
    <van-grid :column-num="2" :gutter="10" class="feature-grid">
      <van-grid-item>
        <div class="feature-item" @click="handleQrScan">
          <van-icon name="scan" size="32" color="#1989fa" />
          <span class="feature-text">扫码报名</span>
          <span class="feature-desc">扫描场地二维码</span>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="feature-item" @click="goToMatchSignup">
          <van-icon name="records" size="32" color="#07c160" />
          <span class="feature-text">比赛报名</span>
          <span class="feature-desc">浏览最新比赛</span>
        </div>
      </van-grid-item>
    </van-grid>

    <!-- 最新活动 -->
    <div class="section-container">
      <div class="section-title">
        <span class="title-text">最新活动</span>
        <van-icon name="arrow" size="16" />
      </div>
      <div class="activity-list">
        <van-card v-for="activity in activities" :key="activity.id" :title="activity.title" :desc="activity.desc"
          :thumb="activity.image" :price="activity.price" :tag="activity.tag">
          <template #footer>
            <van-button size="small" type="primary" @click="viewActivity(activity.id)">
              查看详情
            </van-button>
          </template>
        </van-card>
      </div>
    </div>

    <!-- <LogViewer v-if="isTestEnv" /> -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { showToast } from 'vant';
import util from "../global/util.js";
import logger from '@/global/logger.js';
import env from '@/global/env.js';
import LogViewer from './LogViewer.vue';

const router = useRouter();
const isTestEnv = ref(env.isTestEnv);

// 轮播图数据
const bannerImages = ref([
  require('@/assets/images/homeback.png'),
  require('@/assets/images/homeback.png'),
  require('@/assets/images/homeback.png')
]);

// 最新活动数据
const activities = ref([
  {
    id: 1,
    title: '巨谷周末欢乐赛',
    desc: '本周六下午2点开赛，参与即可获得精美礼品',
    image: require('@/assets/images/homeback.png'),
    price: '50.00',
    tag: '热门'
  },
  {
    id: 2,
    title: '巨谷新手训练营',
    desc: '专业教练指导，零基础也能玩转保龄球',
    image: require('@/assets/images/homeback.png'),
    price: '98.00',
    tag: '推荐'
  }
]);

// 扫码功能
const handleQrScan = () => {
  logger.log('点击了扫码');
  util.goToScanCode();
};

// 比赛报名
const goToMatchSignup = () => {
  router.push('/matchSubjectsApplyInfo');
};

// 查看活动详情
const viewActivity = (id) => {
  showToast('正在实现中，敬请期待');
};

</script>

<style scoped>
.home-page {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.swiper {
  margin-bottom: 16px;
}

.feature-grid {
  margin: 0 12px 16px;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
}

.feature-text {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #323233;
}

.feature-desc {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}

.section-container {
  margin: 0 12px 16px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.title-text {
  font-size: 16px;
  font-weight: bold;
  color: #323233;
}

.activity-list {
  .van-card {
    background-color: #f7f8fa;
    margin-bottom: 8px;
    border-radius: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

:deep(.van-card) {
  background-color: #f7f8fa;
}

:deep(.van-grid-item__content) {
  padding: 0;
}
</style>